import React from "react"
// import styles from "../App.module.css"

const BPMSigns = props => {
  return (
    <button
      className={props.skin}
      onClick={props.click}
      onMouseDown={props.mousedown}
      onMouseUp={props.mouseup}
      onMouseLeave={props.mouseleave}
      onTouchStart={props.touchstart}
      onTouchEnd={props.touchend}
    >
      {props.sign}
    </button>
  )
}

export default BPMSigns
